module.exports = __webpack_public_path__ + "media/luau.43cfddfd.jpg";